// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBhY6SVUgXcoMkpoZCHy5KgA4icBwGq2WM',
    authDomain: 'ourdate-staging.firebaseapp.com',
    databaseURL: 'https://ourdate-staging.firebaseio.com',
    projectId: 'ourdate-staging',
    storageBucket: 'ourdate-staging.appspot.com',
    messagingSenderId: '1006579783948',
    appId: '1:1006579783948:web:e26751661f666162'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
